export default __webpack_public_path__ + "static/05_Dragon-661e8cb0d37be9b88454e13aabfc5235.png";